import { css } from "lit-element";

export const style = css`
	.imageDropzone {
		position: relative;
		border: 2px dashed var(--app-grey);
		background-color: var(--app-lightgrey);

		padding: 10px;
		margin: 0 10px 0 10px;
		font-size: 16px;
		text-align: center;
	}

	.imageDropzone svg {
		width: 50px;
		display: block;
		margin: auto;
	}

	input[type="file"] {
		height: 100%;
		width: 100%;
		position: absolute;
		top: 0;
		right: 0;
		margin: 0;
		padding: 0;
		font-size: 20px;
		cursor: pointer;
		opacity: 0;
		filter: alpha(opacity=0);
	}

	icon {
		font-size: 24px;
	}

	.image img {
		height: var(--input-image-dropzone-height, 150px);
		width: var(--input-image-dropzone-width, auto);
		display: block;
		margin: auto;
		padding-bottom: 5px;

		border-radius: var(--input-image-dropzone-radius, 0px);
	}
`;
